import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=70472a1b&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70472a1b')) {
      api.createRecord('70472a1b', component.options)
    } else {
      api.reload('70472a1b', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=70472a1b&", function () {
      api.rerender('70472a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2SYMROZdzFu/JS/comp/DateRangeExt.vue"
export default component.exports